import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import LoginView from '@/views/LoginView.vue'
import DashBoardView from '@/views/DashBoardView.vue'
import UserRegister from '@/views/user/UserRegister.vue'
import UserAll from '@/views/user/UserAll.vue'
import PasswordReset from '@/views/user/PasswordReset.vue'
import GroupAll from '@/views/group/GroupAll.vue'
import GroupUpdate from '@/views/group/GroupUpdate.vue'
import GroupRegister from '@/views/group/GroupRegister.vue'
import PatientRegister from '@/views/patient/PatientRegister.vue'
import PatientAll from '@/views/patient/PatientAll.vue'
import AssuranceAll from '@/views/assurance/AssuranceAll.vue'
import ServiceAll from '@/views/service/ServiceAll.vue'
import AllDossierDeclasser from '@/views/consultation/AllDossierDeclasser.vue'
import ConsultationDossier from '@/views/consultation/ConsultationDossier.vue'
import NoAccess from '@/views/NoAccess.vue'
import RendezVous from '@/views/consultation/RendezVous.vue'
import ProfileEmploye from '@/views/user/ProfileEmploye.vue'
import FactureForPrint from '@/views/patient/FactureForPrint.vue'
import Preliminaire from '@/views/consultation/preliminaire.vue'
import SpecialiteAll from '@/views/specialite/SpecialiteAll.vue'
import Payment from '@/views/caisse/payment.vue'
import Transaction from '@/views/caisse/transaction.vue'
import Factures from '@/views/caisse/facture.vue'
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'LoginView',
    component: LoginView,
    beforeEnter: (to, from, next) => {
      const user = JSON.parse(localStorage.getItem('user_zgh')||'null');
      // const user = JSON.parse(sessionStorage.getItem('user')|| 'null');
      if (user && user.token) {
        // L'utilisateur est authentifié, donc nous lui permettons l'accès
        next('/dashboard');
      } else {
        // L'utilisateur n'est pas authentifié, donc nous le redirigeons vers la page de connexion
        next();
      }

    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashBoardView,
    meta: { requiresAuth: true },
  },
  {
    path: '/user-register',
    name: 'user-register',
    component: UserRegister,
    meta: { requiresAuth: true },
  },
  {
    path: '/user-all',
    name: 'user-all',
    component: UserAll,
    meta: { requiresAuth: true },
  },
  {
    path: '/reset-password/:id',
    name: 'reset-password',
    component: PasswordReset
  },
  {
    path: '/group-register',
    name: 'group-register',
    component: GroupRegister,
    meta: { requiresAuth: true },
  },
  {
    path: '/group-all',
    name: 'group-all',
    component: GroupAll,
    meta: { requiresAuth: true },
  },
  {
    path: '/group-update/:id',
    name: 'group-update',
    component: GroupUpdate,
    meta: { requiresAuth: true },
  },
  {
    path: '/patient-register',
    name: 'patient-register',
    component: PatientRegister,
    meta:{ requiresAuth:true}
  },
  {
    path: '/patient-all',
    name: 'patient-all',
    component: PatientAll,
    meta: { requiresAuth: true },
  },
  {
    path: '/assurance-all',
    name: 'assurance-all',
    component: AssuranceAll,
    meta: { requiresAuth: true },
  },
  {
    path: '/service-all',
    name: 'service-all',
    component: ServiceAll,
    meta: { requiresAuth: true },
  },
  {
    path: '/dossier-declasser',
    name: 'dossier-declasser',
    component: AllDossierDeclasser,
    meta: { requiresAuth: true },
  },
  {
    path: '/consultation-preliminaire',
    name: 'consultation-preliminaire',
    component: Preliminaire,
    meta: { requiresAuth: true },
  },
  {
    path: '/consultation-dossier/:dossier',
    name: 'consultation-dossier',
    component: ConsultationDossier,
    meta: { requiresAuth: true },
  },
  {
    path: '/rendez-vous',
    name: 'rendez-vous',
    component: RendezVous,
    meta: { requiresAuth: true },
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfileEmploye,
    meta: { requiresAuth: true },
  },
  {
    path: '/specialite-all',
    name: 'specialite-all',
    component: SpecialiteAll,
    meta: { requiresAuth: true },
  },
  {
    path: '/payer-facture',
    name: 'payer-facture',
    component: FactureForPrint,
    meta: { requiresAuth: true }, 
  },
  {
    path: '/payment/:facture?',
    name: 'payment',
    component: Payment,
    meta: { requiresAuth: true }, 
  },
  {
    path: '/factures',
    name: 'factures',
    component: Factures,
    meta: { requiresAuth: true }, 
  },
  {
    path: '/transactions',
    name: 'transactions',
    component: Transaction,
    meta: { requiresAuth: true }, 
  },
  {
    path: '/:catchAll(.*)', // Route catch-all pour 404
    name: 'no-access',
    component: NoAccess,
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const user = JSON.parse(localStorage.getItem('user_zgh') || 'null');
  // const user = JSON.parse(sessionStorage.getItem('user')|| 'null');

  // if (requiresAuth && (!user || !user.token)) {
  //   // Si la route nécessite une authentification et que l'utilisateur n'est pas authentifié, rediriger vers la page de connexion
  //   next('/');
  // } else {


  //   // Sinon, permettre l'accès à la route
  //   next();
  // }
  if (requiresAuth) {
      if (!user || !user.token) {
        // Si l'utilisateur n'est pas authentifié, rediriger vers la page de connexion
        next('/');
      }
      else{
        // Sinon, permettre l'accès à la route
          next();
      }
  } else {
    // Si la route n'exige pas d'authentification, permettre l'accès à la route
    next();
  }

});
export default router
